/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { parseDate } from "utils/Utils";
import goldRatesStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import TableContainer from "@material-ui/core/TableContainer";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { PDFExport } from "@progress/kendo-react-pdf";
import AcknowledgementPayment from "views/admin/components/Acknowledgementpayment/AcknowledgementPayment";
import FileUploadDisbursal from "components/FileUpload/FileUploadDisbursal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ConfirmationModal from "views/admin/components/ConfirmationModal";
import OtpModal from "../OtpModal/OtpModal";
import {
  Grid,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";
import ToastModal from "views/components/ToastModal";
import { useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import { removeSpecialCharFileName } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { formatAmount } from "utils/Utils";
import DisbursalSendBack from "./DisbursalSendBack";
const useStyles = makeStyles(tableStyle);

const DisbursalBT = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumbedisbusalDetails,
  setDisbursalLoan,
  status,
  closeModal,
  customerProceedId,
  loanAccountNumber,
  userDetails,
  applicantDetails,
  yearlyCashValue,
  financialYearCashValidationFlag,
  seletedBranchCode,
  leadBranchCode,
  featureFlags,
  cashAmountPerLoanDisbursalTime
}) => {
  const classes = useStyles();
  let fileUploadComponent = useRef();
  const pdfExportComponent = React.useRef(null);
  const [disbursalDates, setDisbursalDates] = useState(new Date());
  const [tableColumns] = useState([
    "Disbursal Amount",
    "Net Amount Payable",
    "Cash",
    "Bank",
  ]);
  const navigate = useNavigate();
  const [lastIndex, setLastIndex] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [logo, setLogo] = useState("");
  const [isbankDetailsAvaliable, setIsBankDetailsAvaliable] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [loanamount, setLoanamount] = useState("");
  const [applicationLoanId, setLoanAppilcationId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileName, setFileName] = useState("");
  const [msg, setMsg] = useState("");
  const [head, setHead] = useState("");
  const [show, setShow] = useState(false);
  const [loanStatus, setStatus] = useState("");
  const [checkId, setCheckId] = useState(true);
  const [calculatenetPayAble, setCalculatenetPayable] = useState("");
  const [cash, setCash] = useState(0);
  const [bankAmount, setBankAmount] = useState("");
  const [featureFlag,setFeatureaFlag]=useState({});
  const handleClose = () => {
    setShowModal(!showModal);
  };
  const outletData = featureFlags;
  const disableCashField = parseAndSetFlag(outletData.disableCashFieldDisbursal);
  const PANCRITERIA = Number(yearlyCashValue);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    GetAccountDetails();
    GetLogoLink();
  }, []);

  const GetLogoLink = async () => {
    const result = await apiHandler({
      url: endpoint.LOGO_URL,
      method: "GET",
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setLogo(result?.data?.logo);
    }
  };

  const GenerateReceiptNumber = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.RECEIPT_NUMBER + "?branchCode=" + leadBranchCode,
      authToken: authToken,
      method: "POST",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      await setPaymentReferenceNumber(result?.data?.ReceiptNum);
      onGenerate();
    }
  };

  //LOAN_CLOSURE_DUES

  const getPawanTicketDetails = async (bankAccount) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PawanTicket_Detials_get + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result.data) {
      setLoanamount(result?.data?.actualLoanAmount);
      setCalculatenetPayable(result?.data?.actualLoanAmount);
      if (bankAccount) {
        setBankAmount(result?.data?.actualLoanAmount);
      } else {
        setCash(result?.data?.actualLoanAmount);
      }
    }
  };

  const GetAccountDetails = async () => {
    setCallInProgress(true);
    //BANKINFORMATION_GETDATA
    const result = await apiHandler({
      url:
        endpoint.BANKINFORMATION_GETDATA +
        "?" +
        "applicationId=" +
        loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code === 404) {
      setIsBankDetailsAvaliable(false);
      getPawanTicketDetails(false);
    }else if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      await setIsBankDetailsAvaliable(result?.data?.accountNumber !== null);
      getPawanTicketDetails(result?.data?.accountNumber);
    }
  };
  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    if (name === "cash") {
      setCash(Number(value));
      setBankAmount(
        calculatenetPayAble - value > 0 ? calculatenetPayAble - value : 0
      );
    }
  };
  const validateSave = () => {
    if(bankAmount < 0 || cash < 0 || (bankAmount - cash < 0 && isbankDetailsAvaliable)){
      toastUpdate("Error","None of Cash or Bank Amount will be in negative", true);
      return false;
    }
    if (Number(cash) > PANCRITERIA) {
      if(PANCRITERIA < 0){
        toastUpdate("Error",`This customer id already exceed cash limit`, true);
        return false;
      }
      toastUpdate("Error",`Cash Amount will not exceed ${PANCRITERIA}`, true);
      return false;
    }
    return true;
  };
  const validateData = (data) => {
    let hasAdjustmentYes = false;
    let cashPayable = 0;
    let bankPayable = 0;

    for (const item of data) {
      // Check for "adjustment": "YES"
      if (item.adjustment === 'YES') {
        hasAdjustmentYes = true;
        if (item.adjustedAmount === '' || typeof item.adjustedAmount === 'undefined'  || item.adjustedAmount === null) {
          toastUpdate('Error','Error: adjustedAmount cannot be null or Empty when adjustment is YES.',true);
          return false;
        }
      }

      // Check paymentMode for CASH and BANK and accumulate netPayable
      if (item.paymentMode === 'CASH' && item.netPayable) {
        cashPayable += item.netPayable;
      }
      if (item.paymentMode === 'BANK' && item.netPayable) {
        bankPayable += item.netPayable;
      }
    }

    // If no "adjustment": "YES", then check netPayable for CASH and BANK
    if (!hasAdjustmentYes) {
      if (cashPayable <= 0 && bankPayable <= 0) {
        toastUpdate('Error','Error: netPayable cannot be zero for either CASH or BANK.',true);
        return false;
      }
    }

    return true
  };
  const payNowData = async (fileName) => {
    if (cash > 0 && fileUpload === "") {
      setCallInProgress(false);
      toastUpdate("Error", "Please upload cash acknowledgment", true);
      return false;
    }

    // setCallInProgress(true);
    let arr = [];
    if (cash > 0 && isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
        cashReceiptLink:fileName,
      });
    }
    if (!isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
        cashReceiptLink:fileName,
      });
    }
    if (bankAmount > 0 && isbankDetailsAvaliable) {
      arr.push({
        disbursalAmount: loanamount,
        netPayable: bankAmount,
        paymentMode: "BANK",
      });
    }
    if(cash === 0 && bankAmount === 0){
      arr.push({
        disbursalAmount: loanamount,
        netPayable: cash,
        paymentMode: "CASH",
      });
    }
    if(validateData(arr)){
    const res = await apiHandler({
      url: endpoint.DISBURSAL_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        disbursalDate: parseDate(disbursalDates),
        applicationDisbursalDetailDtos: arr,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      setLoanAppilcationId(res?.data?.id);
      if(!res?.data?.skipOtp){
        setShowModal(true);
      }else{
        toastUpdate("Success", res?.data?.message, true);
            navigate("/loanservice/disbursal", { state: { from: '' } });
      }
    }
  }
  };
  const onBack = () => {
    setBack();
  };
  const onNext = () => {
    setNext();
  };

  // delete function
  const onClickData = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setConfirmationModalHeader("Generate Cash Acknowledgement");
    setConfirmationModalMsg(
      "After receipt, you will not be able to change your CASH amount. Do you want to continue ?"
    );
    // setDeletePincodeId(pincode);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    //setDeleteUserId("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    GenerateReceiptNumber();
  };
  const onGenerate = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  const onUpload = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (validateSave()) {
      setCallInProgress(true);
      if (fileUpload) {
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(fileUpload.name)
        formData.append("file", fileUpload, fileName);
        const result = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        const uploadedPath = result.data;
        setFileName(uploadedPath.name);
        payNowData(uploadedPath.name);
      } else {
        payNowData("");
      }
      setCallInProgress(false);
    }
  };
  const resendOtp = async () => {
    const otpResponse = await apiHandler({
      url: endpoint.DISBURSAL_RESEND_OTP + applicationLoanId,
      method: "PUT",
      authToken: authToken,
    });
    if (otpResponse?.data?.error_code) {
      toastUpdate("Error", "Please fill the correct Details", true);
      return;
    } else {
      setMsg("OTP Sent Successfully");
      setHead("Information");
      setShow(true);
    }
  };

  const validateOtp = async (code) => {
    const result = await apiHandler({
      url: endpoint.DISBURSAL_VALIDATE_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        id: applicationLoanId,
        otp: code,
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
    } else {
      setShowModal(false);
      toastUpdate("Success", result?.data?.message, true);
        navigate("/loanservice/disbursal", { state: { from: '' } });
    }
  };

  const handleDateChange = (date) => {
    setDisbursalDates(date);
  };
  const bankAmountFiled = cash <= 0 ? bankAmount : bankAmount - cash;

 const paymentAcknowledgeBranchName = leadBranchCode
  ? userDetails?.branches?.find(item => item.branchCode === leadBranchCode)?.branchName
  : userDetails?.branchName;
return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
             <SubHeader
                      label={headerLabel?.disbursal}
                      subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                      onlyLabel/>
        </Grid>
      </Grid>
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={3}
            lg={3}
            style={{ textAlign: "start" }}
          >
            <CustomInput
              labelText="Loan Account Number"
              formControlProps={{
                fullWidth: true,
                style: { marginTop: 0 },
              }}
              id="loan_account-number"
              inputProps={{
                name: "loan Account Number",
                disabled: true,
                value: loanAccountNumber,
              }}
            />
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={3}
            lg={3}
            style={{ textAlign: "start" }}
          >
            <CustomInput
              labelText="Customer Id"
              formControlProps={{
                fullWidth: true,
                style: { marginTop: 0 },
              }}
              id="customer_id"
              inputProps={{
                name: "customer Id",
                disabled: true,
                value: customerProceedId,
              }}
            />
          </GridItem>
          <GridItem xs={10} sm={10} md={2} lg={2}></GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{ textAlign: "start" }}
          >
            <CustomDateField
              onChange={handleDateChange}
              value={disbursalDates ? disbursalDates : null}
              label="Disbursal Date"
              disabled= {paymentReferenceNumber || status === "DISBURSALTOLMS"}
            />
          </GridItem>
        </GridContainer>
          <TableContainer className={classes.tableContianer}>
            <Table
              stickyHeader
              style={{
                minWidth: window.innerWidth < 600 ? "250%" : "100%",
              }}
            >
              <TableHead>
                <TableRow className={classes.tableHeadRowDisbursal}>
                  {tableColumns.map((item, i) => (
                    <TableCell
                      key={i}
                      padding="checkbox"
                      className={classes.tableCellDisbursal1}
                    >
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                    <TableRow className={classes.tableBodyRowDisbursal}>
                      <TableCell className={classes.disbursalBT}>
                        {
                          <CustomInput
                            id="disbursal_amount"
                            formControlProps={{
                              fullWidth: true,
                              style: { marginTop: 0 },
                            }}
                            inputProps={{
                              name: "disbursalAmount",
                              disabled: true,
                              value: formatAmount(loanamount),
                              onChange: (event) => {
                                handleChange(event);
                              },
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell className={classes.disbursalBT}>
                        {
                          <CustomInput
                            id="net_payable"
                            formControlProps={{
                              fullWidth: true,
                              style: { marginTop: 0 },
                            }}
                            inputProps={{
                              name: "netPayable",
                              value: calculatenetPayAble,
                              disabled: true,
                              onChange: (event) => {
                                handleChange(event);
                              },
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell className={classes.disbursalBT}>
                        {
                          <CustomInput
                            id="cash"
                            formControlProps={{
                              fullWidth: true,
                              style: { marginTop: "12px" },
                            }}
                            inputProps={{
                              name: "cash",
                              type: "number",
                              classes: { input: classes.inputStyle },
                              disabled: (!isbankDetailsAvaliable || (calculatenetPayAble > 0 && loanamount > PANCRITERIA && disableCashField)),
                              value: cash,
                              onChange: (event) => {
                                handleChange(event);
                              },
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell className={classes.disbursalBT}>
                        {
                          <CustomInput
                            id="bank_amount"
                            formControlProps={{
                              fullWidth: true,
                              style: { marginTop: 0 },
                            }}
                            inputProps={{
                              name: "bank",
                              type: "number",
                              value: bankAmount,
                              disabled: true,
                            }}
                          />
                        }
                      </TableCell>
                    </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <PDFExport
                ref={pdfExportComponent}
                paperSize="auto"
                margin={40}
                fileName={`Acknowledgement_Payment_${loanAccountNumber}.pdf`}
              >
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    position: "absolute",
                    left: "-1500px",
                    top: 0,
                  }}
                >
                  <AcknowledgementPayment
                    customerInfoData={{
                      loanAccountNumber: loanApplicationNumbedisbusalDetails,
                      paymentReferenceNum: paymentReferenceNumber,
                      disbursalAmount: cash,
                      paymentMode: "CASH",
                      disbursalDate: disbursalDates,
                      customerName:
                        applicantDetails && applicantDetails?.nameOnAdhaar,
                      transactionBranchName: paymentAcknowledgeBranchName,
                      imagelogo: logo,
                      maker: userDetails?.username,
                    }}
                  />
                </GridItem>
              </PDFExport>
            </GridItem>
          </GridContainer>
          <GridContainer>
              <GridItem
                xs={12}
                sm={6}
                md={6}
                lg={6}
                style={{ textAlign: "start", marginTop: "20px" }}
              >
                {cash > 0 && cash <=  PANCRITERIA && calculatenetPayAble >= 0 && (
                  <div style={{ display: "flex" }}>
                    <Button
                      round={false}
                      className={classes.nextButton1}
                      onClick={(event) => onClickData(event)}
                      style={{ margin: "0px 10px" }}
                    >
                      <span>Generate</span>
                    </Button>
                    <FileUploadDisbursal
                      addButtonProps={{
                        color: "info",
                        round: false,
                      }}
                      changeButtonProps={{
                        color: "info",
                        round: false,
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: false,
                      }}
                      removeFile={() => setFileUpload("")}
                      sendFile={(file) => {
                        setFileUpload(file);
                      }}
                      ref={fileUploadComponent}
                    />
                  </div>
                )}
              </GridItem>
            <GridItem
              xs={12}
              sm={6}
              md={6}
              lg={6}
              style={{
                textAlign: window.innerWidth < 360 ? "center" : "right",
                marginTop: "10px",
              }}
            >
              <DisbursalSendBack
                 loanApplicationId={loanApplicationId}
                 classes={classes}
                 callInProgress={callInProgress}
                 setCallInProgress={setCallInProgress}
                 toastUpdate={toastUpdate}
                 navigateTo={"/loanservice/disbursal"}
               />
              <Button
                key={"btnB"}
                size="small"
                className={classes.nextButton1}
                disabled={callInProgress}
                onClick={() => onBack()}
              >
                Back
              </Button>

                  <Button
                    key={"btnP"}
                    size="small"
                    className={classes.nextButton}
                    disabled={
                      callInProgress ||
                      calculatenetPayAble < 0 ||
                      loanStatus?.toLowerCase() === "closed" ||
                      !checkId
                    }
                    onClick={(event) => onUpload(event)}
                  >
                    Submit
                  </Button>
            </GridItem>
          </GridContainer>

          {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {showModal && (
        <OtpModal
          handleClose={handleClose}
          showModal={showModal}
          Otp={validateOtp}
          ResendOtp={resendOtp}
          message={msg}
          header={head}
          show={show}
        />
      )}
    </div>
  );
};

DisbursalBT.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  closeModal: PropTypes.func,
  loanApplicationId: PropTypes.number,
};

export default withStyles(goldRatesStyle)(DisbursalBT);
